// GLB — Filtra varianti Duration in base al Piano selezionato
// Aggiungere in: Online Store → Themes → Edit code → Assets → glb-variants.js
// Poi includere nel tema con: <script src="{{ 'glb-variants.js' | asset_url }}" defer></script>

(function() {

  // Mappa: quale Piano mostra quali opzioni Duration
  const planDurationMap = {
    '2-Weeks Trial':      ['Standard'],
    'School Term Plan':   ['10 Weeks', '9 Weeks', '8 Weeks', '7 Weeks', '6 Weeks', '5 Weeks', '4 Weeks', '3 Weeks', '2 Weeks', '1 Week'],
    'Annual':             ['Standard'],
  };

  // Etichette da nascondere nel secondo dropdown quando non pertinenti
  // (Candy theme usa <select> o bottoni — gestiamo entrambi i casi)

  function updateDurationOptions(selectedPlan) {
    const allowed = planDurationMap[selectedPlan] || [];

    // --- CASO 1: il tema usa <select> per le varianti ---
    const durationSelects = document.querySelectorAll('select[name="options[Duration]"], select[id*="duration"], select[id*="Duration"]');
    durationSelects.forEach(function(select) {
      Array.from(select.options).forEach(function(option) {
        const val = option.value.trim();
        if (allowed.includes(val)) {
          option.disabled = false;
          option.hidden   = false;
          option.style.display = '';
        } else {
          option.disabled = true;
          option.hidden   = true;
          option.style.display = 'none';
        }
      });

      // Se il valore attualmente selezionato non è più disponibile, setta il primo disponibile
      if (!allowed.includes(select.value.trim())) {
        const firstAllowed = Array.from(select.options).find(o => !o.disabled);
        if (firstAllowed) {
          select.value = firstAllowed.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // --- CASO 2: il tema usa bottoni/pill per le varianti ---
    const durationButtons = document.querySelectorAll('[data-option-position="2"] .swatch, [data-option-position="2"] button, [data-option-index="1"] button, [data-option-index="1"] .swatch');
    durationButtons.forEach(function(btn) {
      const val = (btn.dataset.value || btn.textContent || '').trim();
      if (allowed.includes(val)) {
        btn.style.display = '';
        btn.disabled = false;
        btn.classList.remove('glb-hidden-variant');
      } else {
        btn.style.display = 'none';
        btn.disabled = true;
        btn.classList.add('glb-hidden-variant');
      }
    });

    // --- CASO 3: Candy usa dropdown custom con label visibili ---
    // Cerca i wrapper degli option items
    const durationItems = document.querySelectorAll('[data-option="Duration"] .option__item, .variant-option--duration .option__item');
    durationItems.forEach(function(item) {
      const label = item.querySelector('label, span, input');
      const val = label ? (label.dataset.value || label.textContent || label.value || '').trim() : '';
      if (allowed.includes(val)) {
        item.style.display = '';
        item.classList.remove('glb-hidden-variant');
      } else {
        item.style.display = 'none';
        item.classList.add('glb-hidden-variant');
      }
    });

    // Nascondi l'intero blocco Duration se c'è solo 'Standard'
    const durationWrapper = document.querySelector('[data-option="Duration"], .variant-option--duration, fieldset:has([name*="Duration"])');
    if (durationWrapper) {
      if (allowed.length === 1 && allowed[0] === 'Standard') {
        durationWrapper.style.display = 'none';
      } else {
        durationWrapper.style.display = '';
      }
    }
  }

  function init() {
    // Trova il dropdown/select del Piano (primo option)
    const planSelects = document.querySelectorAll('select[name="options[Plan]"], select[id*="plan"], select[id*="Plan"]');
    planSelects.forEach(function(select) {
      select.addEventListener('change', function() {
        updateDurationOptions(this.value.trim());
      });
      // Applica subito al caricamento
      updateDurationOptions(select.value.trim());
    });

    // Bottoni Piano (se il tema usa bottoni invece di select)
    const planButtons = document.querySelectorAll('[data-option-position="1"] button, [data-option-position="1"] .swatch, [data-option-index="0"] button');
    planButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        setTimeout(function() {
          const activePlan = document.querySelector('[data-option-position="1"] button.active, [data-option-position="1"] button[aria-pressed="true"], [data-option-index="0"] button.active');
          if (activePlan) {
            updateDurationOptions((activePlan.dataset.value || activePlan.textContent || '').trim());
          }
        }, 50);
      });
    });

    // Candy potrebbe caricare le varianti in modo asincrono — retry se non trovato subito
    const planDropdown = document.querySelector('select[name="options[Plan]"]');
    if (planDropdown) {
      updateDurationOptions(planDropdown.value.trim());
    }
  }

  // Aspetta che il DOM sia pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Osserva cambiamenti dinamici (alcuni temi caricano varianti via AJAX)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.addedNodes.length) {
        const planDropdown = document.querySelector('select[name="options[Plan]"]');
        if (planDropdown) {
          updateDurationOptions(planDropdown.value.trim());
        }
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
